import { playAudio } from "../../speak/playAudio";

/** show a link that plays a recording */
export function PlayUrl(props: { url: string }) {
  function onClick() {
    playAudio(props.url);
  }

  const playButton = '\u23f5';
  return (<span onClick={onClick} className='play'>
    {playButton}
    recording
  </span>);
}
